<template>
  <div>
    <main-layout>
      <v-container>
        <div>
          <v-layout wrap class="pt-4">
            <v-flex xs6>
              <h5>{{ $t('shop_management') }}</h5>
            </v-flex>
            <v-flex xs6 class="text-xs-right">
              <importxlsx :loading="importLoading" @onChange="handleImportBranch"></importxlsx>
            </v-flex>
          </v-layout>
        </div>
        <v-data-table
          hide-actions
          :loading="loading"
          :headers="headers"
          :items="branchData"
          :pagination.sync="pagination"
          class="elevation-1 mt-3"
        >
          <template v-slot:items="props">
            <tr>
              <td>{{ props.item.shop_id }}</td>
              <td>{{ props.item.branch || '-' }}</td>
              <td class="text-xs-right">
                <v-btn dark small color="primary" @click="handleShowSubBranch(props.item.shop_id)">
                  {{ $t('view') }}
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
        <div class="mt-2">
          <v-pagination
            :total-visible="6"
            v-model="pageNumber"
            @input="handleChangePage"
            :length="pagelength"
          ></v-pagination>
        </div>
      </v-container>
    </main-layout>
  </div>
</template>

<script>
import powerbuyShopServicesApi from '@/api/powerbuy-shop-services'
import { mapGetters } from 'vuex'
import XLSX from 'xlsx'
import moment from 'moment'
import HeaderTableWithSort from '@/components/elements/HeaderTableWithSort.vue'
import { ORDER_BY } from '@/constants/orderBy.js'
import { DATETIME } from '@/constants/datetime.js'
import importxlsx from '@/components/elements/importxlsx.vue'

export default {
  components: {
    HeaderTableWithSort,
    importxlsx
  },
  data() {
    return {
      limit: 10,
      offset: 0,
      pagination: { rowsPerPage: -1, sortBy: '' },
      total: 0,
      pagetmp: 1,
      pageNumber: 1,
      loading: false,
      headers: [
        { text: 'Shop ID', value: 'shop_id', sortable: false },
        { text: 'Branch Name', value: 'branch', sortable: false },
        { text: '', value: '', sortable: false }
      ],
      sortBy: 'id',
      orderBy: ORDER_BY.DESC,
      importLoading: false,
      branchData: []
    }
  },
  async mounted() {
    await this.handleGetBranch()
  },
  computed: {
    ...mapGetters(['selectedBot']),
    pagelength() {
      if (this.total) {
        let total = parseFloat(this.total)
        return Math.ceil(total / this.limit)
      } else {
        return 1
      }
    }
  },
  methods: {
    async handleGetBranch() {
      const vm = this
      try {
        const response = await vm.getBranch()
        if (response) {
          vm.branchData = response.data
          vm.total = response.total
        }
      } catch (error) {
        console.error(error)
        return
      }
    },
    async getBranch() {
      const vm = this
      try {
        let data = {
          pageId: vm.selectedBot.pageid,
          limit: vm.limit,
          offset: vm.offset
        }

        vm.$store.dispatch('loading')
        const response = await powerbuyShopServicesApi.getBranchMain({
          config: {
            params: data
          }
        })

        vm.$store.dispatch('loading')
        if (response && response.status === 200) {
          return response.data
        } else {
          return null
        }
      } catch (error) {
        console.error(error)
      }
    },
    handleImportBranch(item) {
      const vm = this
      try {
        vm.importLoading = true
        let data = {
          pageid: vm.selectedBot.pageid,
          files: item[0]
        }

        powerbuyShopServicesApi.importBranch(data, async (err, response) => {
          vm.importLoading = false
          if (err) {
            console.error(err)
            return
          }

          if (response && response.responsecode == 200) {
            await vm.$swal.fire({
              text: 'สำเร็จ',
              type: 'success'
            })
          } else {
            await vm.$swal.fire({
              text: 'ข้อมูลไม่ถูกต้อง'
            })
          }
        })
      } catch (error) {
        vm.importLoading = false
        console.error(error)
      }
    },
    handleChangePage(val) {
      const vm = this
      if (this.pagetmp !== val) {
        vm.pagetmp = val
        vm.offset = vm.pageNumber * vm.limit - vm.limit

        vm.handleGetBranch()
      }
    },
    handleShowSubBranch(id) {
      this.$router.push(`branch-management/view/${id}`)
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/powerbuy/BranchManagement/BranchManagement.vue